export const LOGIN_REQUEST = 'USER/LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'USER/LOGIN_SUCCESS';
export const LOGIN_FAIL = 'USER/LOGIN_FAIL';
export const LOGIN_LOGOUT = 'USER/LOGIN_LOGOUT';
export const CHANGE_USER_INFO = 'USER/CHANGE_USER_INFO';
